import $regs from './reg'

export const accountValidator = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请输入手机号'))
  }
  const verify = $regs.isPhoneNu(value)
  if (!verify) {
    return callback(new Error('格式有误，请输入正确的手机号'))
  }
  return callback()
}

export const phoneValidator = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请输入联系方式'))
  }
  const verify = $regs.isPhoneOrTelNu(value)
  if (!verify) {
    return callback(new Error('格式有误，请输入正确的手机号'))
  }
  return callback()
}

export const passwordValidator = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请输入密码'))
  } else if (!$regs.isPassword(value)) {
    return callback(new Error('格式有误, 输入的密码为6到18位字母或数字组合'))
  }
  return callback()
}

export const idCardValidator = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请输入身份证号'))
  } else if (!$regs.isIdCard(value)) {
    return callback(new Error('格式有误, 请输入正确的身份证号码'))
  }
  return callback()
}

export const verifyCodeValidator = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请输入验证码'))
  }
  const verify = $regs.testVerifyCode(value)
  if (!verify) {
    return callback(new Error('格式有误，请输入正确的验证码'))
  }
  return callback()
}

export const bankNumValidator = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请输入银行账户'))
  }
  const verify = $regs.isBankNum(value)
  if (!verify) {
    return callback(new Error('格式有误，请输入正确的银行账户'))
  }
  return callback()
}

export const positiveIntValidator = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('该值不能为空'))
  }
  const verify = $regs.isPositiveInt(value)
  if (!verify) {
    return callback(new Error('格式有误，请输入一个正整数'))
  }
  return callback()
}

export const positiveNumberValidator = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入'))
  }
  const verify = $regs.isPositiveNumber(value)
  if (!verify) {
    return callback(new Error('格式有误, 请输入一个正数'))
  }
  return callback()
}



// WEBPACK FOOTER //
// ./src/utils/validators.js